export default __webpack_public_path__ + "3af5e564d7973367c5fc9044a9545e22.png";